import React from 'react';
import BottomModal from './BottomModal';
import { _update } from '../_Store';
import Item from '../pages/Item';
import { types } from 'utils';

interface StateProps {
	selectedProduct: types.Item;
	isItemModalOpen: boolean;
	setOpenedItemModal: (state: boolean) => void;
}

interface Props extends StateProps {}
const ItemBottomModal: React.FC<Props> = ({
	selectedProduct,
	isItemModalOpen,
	setOpenedItemModal,
}) => {
	return (
		<React.Fragment>
			<BottomModal
				open={isItemModalOpen}
				title={selectedProduct?.name}
				onClose={() => {
					_update.data('is_bottom_modal', { is_open: false });
					setOpenedItemModal(false);
				}}
			>
				<Item
					item={selectedProduct}
					handleCloseModal={() => {
						setOpenedItemModal(false);
						_update.data('is_bottom_modal', { is_open: false });
					}}
					cartItemId={selectedProduct.cartItemId}
				/>
			</BottomModal>
		</React.Fragment>
	);
};

export default ItemBottomModal;
